<template>
    <div v-if="show" class="mask" @click.self="close">
        <div class="modal">
            <div class="title">{{ title }}</div>
            <div class="content">
                <div>{{ content }}</div>
                <slot />
            </div>
            <div class="btn-group" v-if="isFooterBtn">
                <button class="btn cancel" @click="handleCancel">取消</button>
                <button class="btn confirm" @click="handleConfirm">{{confirmText}}</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        isFooterBtn: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            show: false,
            title: '提示',
            content: '',
            confirmCb: null,
            cancelCb: null,
            confirmText: '确定'
        }
    },
    methods: {
        // 打开弹窗
        open(options) {
            this.title = options.title || '提示'
            this.content = options.content || ''
            this.confirmCb = options.onConfirm
            this.cancelCb = options.onCancel
            this.confirmText = options.confirmText || '确定'
            this.show = true
        },
        // 关闭弹窗
        close() {
            this.show = false
        },
        handleConfirm() {
            this.close()
            this.confirmCb && this.confirmCb()
        },
        handleCancel() {
            this.close()
            this.cancelCb && this.cancelCb()
        }
    }
}
</script>

<style scoped>
.mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}
.modal {
    width: 320px;
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
}
.title {
    padding: 16px;
    font-size: 16px;
    text-align: center;
    font-weight: 500;
    border-bottom: 1px solid #eee;
}
.content {
    padding: 20px 16px;
    font-size: 14px;
    color: #333;
    text-align: center;
    overflow-y: scroll;
    max-height: 80vh;
}
.btn-group {
    display: flex;
    border-top: 1px solid #eee;
}
.btn {
    flex: 1;
    height: 44px;
    border: none;
    background: #fff;
    font-size: 14px;
    cursor: pointer;
}
.cancel {
    border-right: 1px solid #eee;
    color: #666;
}
.confirm {
    color: #409eff;
}
</style>